import stores from '../vuex';
import {http} from './config';

export default {

    companyResume: (companyId, allotmentId) => {
        if (allotmentId === 'selecione') allotmentId = null
        return http.get('api/v1/dashboard/resumoPorCompanhia', {
            headers: {'company-id': companyId},
            params:{allotmentId}
        });
    },
    getQtdPeople: () => {
        return http.get('api/v1/dashboard/resumoPorCompanhia', {
            params:{onlyPeople:true}
        });
    },
    getQtdProposalByStatus: (allotmentId) => {
        return http.get(`api/v1/dashboard/propostas/qtdPorStatus?allotmentId=${allotmentId}`);
    },
    getProgressProposalAdd: (allotmentId, day = null) => {
        if (day){
            return http.get(`api/v1/dashboard/propostas/progressoDeCadastro?allotmentId=${allotmentId}&days=30`);
        }
        return http.get(`api/v1/dashboard/propostas/progressoDeCadastro?allotmentId=${allotmentId}`);
    },
    getQtdProposal: (allotmentId) => {
        return http.get('api/v1/dashboard/resumoPorCompanhia', {
            params:{onlyProposal:true, allotmentId}
        });
    },
    getQtdAllotment: () => {
        return http.get('api/v1/dashboard/resumoPorCompanhia', {
            params:{onlyAllotment:true}
        });
    },
    resumReserveByType: (allotmentId) => {
        return http.get('api/v1/dashboard/reservas-por-tipo', {headers: {'allotment-id': allotmentId}});
    },
    summaryLotsByAllotment: (allotmentId) => {
        return http.get('api/v1/dashboard/loteamento/resumo/lotes', {headers: {'allotment-id': allotmentId}});
    },
    summaryReservesByAllotment: (allotmentId) => {
        if (!allotmentId || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/loteamento/resumo/reservas', {params: {allotmentId}});
    },
    datasAnual: (companyId) => {
        return http.get(`api/v1/dashboard/progressoMovimentacoesPorCompanhia/yearInitial/yearFinal`, {headers: {'company-id': companyId}});
    },

    exportResumBrokerByAllotment: (allotmentId, type = '1', dayS = null, dayE = null) => {
        stores.commit('changeLoading', true);
        const responseType = 'blob';
        const headers = {
            filter: type === '1' ? 'values-reservas-confirmed' : 'total-reservas-confirmed',
            dayStart: dayS ? dayS : '',
            dayEnd: dayE ? dayE : '',
        };

        if (allotmentId && allotmentId !== 'selecione') headers['allotment-id'] = allotmentId;

        return http.get('api/v1/exportar/resumo-reservas-corretor-por-loteamento', {headers, responseType})
            .then(resp => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'qtd_reservas_corretor.xlsx');
                link.click();
            }).finally(() => stores.commit('changeLoading', false));
    },
    exportResumImobiByAllotment: (allotmentId, type = '1', dayS = null, dayE = null) => {
        stores.commit('changeLoading', true);
        const responseType = 'blob';
        const headers = {
            filter: type === '1' ? 'values-reservas-confirmed' : 'total-reservas-confirmed',
            dayStart: dayS ? dayS : '',
            dayEnd: dayE ? dayE : '',
        };

        if (allotmentId && allotmentId !== 'selecione') headers['allotment-id'] = allotmentId;

        return http.get('api/v1/exportar/resumo-reservas-imobiliaria-por-loteamento', {headers, responseType})
            .then(resp => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'qtd_reservas_imobiliaria.xlsx');
                link.click();
            }).finally(() => stores.commit('changeLoading', false));
    },
    datasAnualReserve: (companyId, allotmentId, days = false) => {
        if (allotmentId && allotmentId !== 'selecione') {
            return http.get(`api/v1/dashboard/progressoReservasPorCompanhia?days=${days}`, {
                headers: {
                    'company-id': companyId,
                    'allotment-id': allotmentId
                }
            });
        }
        return http.get(`api/v1/dashboard/progressoReservasPorCompanhia?days=${days}`, {headers: {'company-id': companyId}});
    },
    getReservesBrokersByAllotment: (allotmentId, type = '1', dayS = null, dayE = null) => {
        if (allotmentId === 'selecione') allotmentId =  null;
        if (type === '2') {
        return http.get('api/v1/dashboard/reservas/corretores-loteamento', {
                headers: {
                    filter: type === '2' ? 'total-reservas-confirmed' : 'value_reservas-confirmed',
                    dayStart: dayS ? dayS : '',
                    dayEnd: dayE ? dayE : '',
                },
                params:{
                    allotmentId
                }
            });
        }
        return http.get(`api/v1/dashboard/reservas/corretores-loteamento`, {
            headers: {
                dayStart: dayS ? dayS : '',
                dayEnd: dayE ? dayE : '',
            },
            params:{
                allotmentId
            }
        });
    },
    getReservesImobiByAllotment: (allotmentId, type = '1', dayS = null, dayE = null) => {
        if (allotmentId === 'selecione') allotmentId = null;
        if (type === '2') {
            return http.get(`api/v1/dashboard/reservas/imobiliarias-loteamento`, {
                headers: {
                    filter: 'total-reservas-confirmed',
                    dayStart: dayS ? dayS : '',
                    dayEnd: dayE ? dayE : '',
                },
                params:{
                    allotmentId
                }
            });
        }
        return http.get(`api/v1/dashboard/reservas/imobiliarias-loteamento`, {
            headers: {
                dayStart: dayS ? dayS : '',
                dayEnd: dayE ? dayE : '',
            },
            params:{
                allotmentId
            }
        });
    },
    totalStoredByCompany: () => {
        return http.get('api/v1/dashboard/drive/totalArmazenado');
    }
}
